module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<h1>Terms of use</h1>\n<div class="content">\n  <a class="btn btn-default" href="' +
((__t = ( URL_TERMS_OF_USE )) == null ? '' : __t) +
'" style="font-size: 1.2em;" target="_blank" rel=\'noopener noreferrer\'>\n    <img src="icon-file-pdf.svg" style="height: 1.2em; vertical-align: top; transform: translate(0, 0.1em);" />\n    PDF\n  </a>\n</div>\n';

}
return __p
}